import * as React from 'react'

export const FooterExpandIcon = () => {
  return (
    <svg width='9' height='5' viewBox='0 0 9 5' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M0.5 0.5L4.5 4.5L8.5 0.5'
        stroke='white'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
